const ss = window.sessionStorage;

export function setItem(key, payload, expire = "1day") {
  return ss.setItem(key, JSON.stringify(payload));
}

export function getItem(key) {
  try {
    const data = ss.getItem(key);
    return JSON.parse(data);
  } catch (e) {
    return null;
  }
}

export function removeItem(key) {
  return ss.removeItem(key);
}
